export default __webpack_public_path__ + "static/media/no-data-found.95f8a2a9.svg";